export default __webpack_public_path__ + "static/media/973.4df11f2d.gif";